import { Link } from 'react-router-dom';

function scrollToPanel(id) {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function NavItem({ label, sublabel, onClick }) {
  return (
    <button
      onClick={onClick}
      className="w-full text-left px-3 py-2 rounded-lg text-sm font-medium text-ink-200 hover:bg-white/5 hover:text-white transition-colors"
    >
      {label}
      {sublabel && <span className="block text-xs font-normal text-ink-400">{sublabel}</span>}
    </button>
  );
}

// Dashboard nav-rail shell for the compras-loader feature, adapted from
// invoice-loader-react's sidebar visual language (dark rail, Panel-based
// content) — sized to this page's actual needs (two country sections, no
// company/verification/F-07 sections, since none of that exists here).
export default function DashboardShell({ children }) {
  return (
    <div className="min-h-screen bg-gray-50 lg:flex overflow-x-hidden">
      <aside className="hidden lg:flex lg:flex-col lg:w-64 lg:shrink-0 bg-ink-900 text-white">
        <div className="p-5 border-b border-white/10">
          <Link to="/" className="text-xs text-ink-300 hover:text-white transition-colors flex items-center gap-1.5 mb-3">
            <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
            </svg>
            Inicio
          </Link>
          <h1 className="text-sm font-bold leading-tight">Cargador de Compras</h1>
          <p className="text-xs text-ink-400 mt-0.5">Costa Rica · El Salvador</p>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          <p className="px-3 pt-2 pb-1 text-[11px] font-semibold uppercase tracking-wide text-ink-400">Países</p>
          <NavItem label="Costa Rica" sublabel="FacturaElectronica" onClick={() => scrollToPanel('panel-costa-rica')} />
          <NavItem label="El Salvador" sublabel="DTE" onClick={() => scrollToPanel('panel-el-salvador')} />
        </nav>
      </aside>

      <header className="lg:hidden bg-white border-b border-gray-200 sticky top-0 z-10">
        <div className="px-4 py-3 flex items-center gap-3">
          <Link to="/" className="text-sm text-gray-500 hover:text-gray-800 transition-colors flex items-center gap-1.5">
            <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
            </svg>
            Inicio
          </Link>
          <div className="h-4 w-px bg-gray-200" />
          <h1 className="text-sm font-bold text-gray-900">Cargador de Compras</h1>
        </div>
      </header>

      <main className="flex-1 min-w-0">
        <div className="max-w-6xl mx-auto px-4 py-6 space-y-8">
          {children}
        </div>
      </main>
    </div>
  );
}
